// src/auth/msalConfig.js
// MSAL configuration for Azure AD authentication.
// Uses the Authorization Code Flow with PKCE — the most secure
// flow for single-page applications. Never uses implicit flow.

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
    // After sign-out, redirect back to the app
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
  },
  cache: {
    // localStorage persists tokens across tab/web-view teardown — essential on
    // iOS, where backgrounding the app (switching to another app and back)
    // tears down the Safari web view and would otherwise wipe sessionStorage,
    // forcing a re-login every time. localStorage survives that, so the MSAL
    // refresh token keeps the session alive for hours across app switches.
    cacheLocation: "localStorage",
    // Cookie fallback helps token/state survive some Safari/iOS edge cases.
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        // Never log PII (personally identifiable information)
        if (containsPii) return;
        if (process.env.NODE_ENV === "development") {
          console.log(`[MSAL] ${message}`);
        }
      },
    },
  },
};

// Scopes requested when signing in
// openid, profile, email — standard OIDC scopes for identity
// api://{clientId}/access_as_user — your backend API scope
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    `api://${process.env.REACT_APP_CLIENT_ID}/access_as_user`,
  ],
};

// Scopes for Microsoft Graph calls (email, calendar)
// These are requested silently after sign-in
export const graphRequest = {
  scopes: [
    "Mail.Read",
    "Mail.ReadWrite",
    "Calendars.Read",
    "User.Read",
  ],
};